var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMorocco2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "47px",
    viewBox: "0 0 71 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Morocco@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-831.000000, -70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "Morocco"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(761.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_7_copy-35",
    fill: "#ED5565",
    x: 0.87,
    y: 0,
    width: 70,
    height: 47,
    rx: 6.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.64,33.18 C29.72,33.83 29.19,33.46 29.45,32.36 L30.45,28.27 C30.6771638,27.047604 30.2751885,25.7928401 29.38,24.93 L26.38,22.34 C25.53,21.6 25.75,20.98 26.87,20.94 L31.06,20.82 C32.2541491,20.7357854 33.2839275,19.949695 33.68,18.82 L35,14.32 C35.32,13.24 35.89,13.22 36.27,14.32 L37.85,18.73 C38.2982557,19.8672799 39.3604942,20.6454766 40.58,20.73 L44.86,20.73 C45.98,20.73 46.21,21.36 45.36,22.1 L42.1,24.95 C41.2086762,25.8054353 40.8294123,27.0645913 41.1,28.27 L42.1,31.87 C42.41,32.96 41.89,33.36 40.93,32.77 L37.46,30.62 C36.3884009,30.0317532 35.0814593,30.0739126 34.05,30.73 L30.64,33.18 Z",
    id: "Shape_2_copy_35-2",
    fill: "#57A863"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorocco2X);
export default __webpack_public_path__ + "static/media/Morocco@2x.2c2582f060705e210bf07d1bda7cd2d3.svg";
export { ForwardRef as ReactComponent };